import { useState, useEffect } from 'react';
import { TenantSelectionEnum } from '../../redux/session/session.slice';
import { useTenants } from '../../hooks/useTenants';
import { useTranslation } from 'react-i18next';
import { InputLabel, FormControl } from '@mui/material';
import { colors } from '../../styles/color-tokens';
import { useNavigate, useLocation } from 'react-router-dom';
import { TenantsDropdown } from './tenants-dropdown';
import { DashboardPaths } from '../../pods/dashboard/dashboard.router';

export const TenantsSelectionDropdown = ({ onChanged }: { onChanged?: (tenantId: string) => void }) => {
  const { selectedTenant, allowedTenants, setSelectedTenant } = useTenants();
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setOpen(false);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!selectedTenant) setSelectedTenant(TenantSelectionEnum.All);
  }, []);

  const handleTenantChange = async (tenantId: string) => {
    if (tenantId === TenantSelectionEnum.All) {
      setSelectedTenant(TenantSelectionEnum.All);
    } else {
      const tenant = allowedTenants.find((tenant) => tenant.id === tenantId);
      if (tenant) {
        setSelectedTenant(tenant);
      }
    }

    if (location.pathname === DashboardPaths.Dashboard) {
      navigate(0);
    } else {
      navigate(DashboardPaths.Dashboard);
    }
    onChanged?.(tenantId);
  };

  return (
    <FormControl variant="filled" sx={{ minWidth: 221 }} className="bg-surface-elevated/50">
      <InputLabel
        sx={{
          fontSize: '0.75rem',
          marginTop: '0.75rem',
          paddingLeft: '6px',
          color: colors.text.secondary,
          '&.Mui-focused': {
            color: colors.text.primary,
          },
        }}
      >
        {t('tenantSelection.tenantLabel')}
      </InputLabel>
      <TenantsDropdown
        value={
          selectedTenant && selectedTenant !== TenantSelectionEnum.All ? selectedTenant?.id : TenantSelectionEnum.All
        }
        items={allowedTenants}
        onChange={(e) => handleTenantChange(e.target.value as string)}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        className="w-full h-16"
      />
    </FormControl>
  );
};
